define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('div', {}, React.createElement('span', {}, this.time), React.createElement('span', {}, this.state.time));
    };
});


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/clock/clock.html.rt
// module id = 4316
// module chunks = 86